import angular from 'angular';
import moment from 'moment';
import { toDate } from './helpers';

angular.module('cloudX').directive('validateDateField', [
  '$window',
  '$filter',
  'relBindSvc',
  function($window, $filter, relBindSvc) {
    return {
      restrict: 'A',
      require: ['?ngModel', '^?bindErrors'],
      link: function(scope, element, attributes, ctrls) {
        var ngModel = ctrls[0];
        var bindErrors = ctrls[1];
        if (!ngModel) {
          var input = element.find('input[ng-model][uib-datepicker-popup]');
          if (!input || !input.length) return;
          ngModel = input.controller('ngModel');
          if (!ngModel) return;
        }
        attributes.$observe('validateDateField', function(value) {
          if (!value) return;
          var fieldDef = scope.$eval(value);
          if (!fieldDef || !fieldDef.validators || !fieldDef.validators.length) return;
          fieldDef.errors = {};
          var getFieldValue = function(field) {
            var relation = relBindSvc.relations[scope.relId];
            if (!relation || !relation[field]) return undefined;
            if (typeof relation[field].value !== 'undefined') return relation[field].value;
            return relation[field];
          };

          ngModel.$validators.date = function(modelValue) {
            if (modelValue === null) return true;
            return angular.isDate(modelValue);
          };
          for (var i = 0; i < fieldDef.validators.length; i++) {
            var validator = fieldDef.validators[i];
            if (!validator) continue;
            if (validator.maximum !== null) {
              if ($window.isGuid(validator.maximum)) {
                if (bindErrors) bindErrors.addError('max', 25, [validator.maximum]);
                ngModel.$validators.max = (function(max) {
                  return function(modelValue) {
                    if (modelValue === null) return true;
                    var other = toDate(getFieldValue(max));
                    if (typeof other === 'undefined' || other === null || isNaN(other)) return true;
                    var value = toDate(modelValue);
                    if (typeof value === 'undefined' || value === null) return false;
                    return value <= other;
                  };
                })(validator.maximum);
              } else {
                if (bindErrors)
                  bindErrors.addError('max', 6, [$filter('formatDate')(validator.maximum)]);
                ngModel.$validators.max = (function(max) {
                  return function(modelValue) {
                    if (modelValue === null) return true;
                    var other = toDate(max);
                    if (typeof other === 'undefined' || other === null) return true;
                    var value = toDate(modelValue);
                    if (typeof value === 'undefined' || value === null) return false;
                    return value <= other;
                  };
                })(validator.maximum);
              }
            }
            if (validator.minimum !== null) {
              if ($window.isGuid(validator.minimum)) {
                if (bindErrors) bindErrors.addError('min', 24, [validator.minimum]);
                ngModel.$validators.min = (function(min) {
                  return function(modelValue) {
                    if (modelValue === null) return true;
                    var other = toDate(getFieldValue(min));
                    if (typeof other === 'undefined' || other === null || isNaN(other)) return true;
                    var value = toDate(modelValue);
                    if (typeof value === 'undefined' || value === null) return false;
                    return value >= other;
                  };
                })(validator.minimum);
              } else {
                if (bindErrors)
                  bindErrors.addError('min', 5, [$filter('formatDate')(validator.minimum)]);
                ngModel.$validators.min = (function(min) {
                  return function(modelValue) {
                    if (modelValue === null) return true;
                    var other = toDate(min);
                    if (typeof other === 'undefined' || other === null) return true;
                    var value = toDate(modelValue);
                    if (typeof value === 'undefined' || value === null) return false;
                    return value >= other;
                  };
                })(validator.minimum);
              }
            }
          }
          //if (bindErrors) {
          //    ngModel.$viewChangeListeners.push(function () {
          //        bindErrors.refreshErrors(ngModel.$error);
          //    });
          //    scope.$on('$destroy', function () {
          //        bindErrors.refreshErrors();
          //    });
          //}
        });
      },
    };
  },
]);
